import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { AllGroupsPage } from '@features/groups/components/pages/AllGroupsPage'
import { CoursesTable } from '@features/groups/components/tables/CoursesTable'
import { groupsQueryOptions } from '@features/groups/queries'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/all/courses')({
    component: RouteComponent,
    loader: async ({ context }) => {
        context.queryClient.ensureQueryData(groupsQueryOptions({ mode: 'all', type: 'course' }))
        return null
    }
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load courses'>
            <Suspense fallback={<LoadingIndicator resource='all courses'/>}>
                <AllGroupsPage
                    title='All courses'
                    renderTable={(columnPreset) => (
                        <CoursesTable
                            columnPreset={columnPreset}
                            mode='all'
                            navMode='id'
                        />
                    )}
                />
            </Suspense>
        </QueryErrorBoundary>
    )
}
